import React, {useState, useRef} from 'react'
import ManageUser from '../../components/Users/ManageUser'
import { useSelector } from 'react-redux'
import SubHeader from '../../components/Subheader/Subheader'
import MainFilter from '../../components/Tools/MainFilter';
import CreateButton from '../../components/Tools/CreateButton';
import DashboardFilter from '../Dashboard/components/DashboardFilter';

const Users = () => {
  const { financialYears, authData } = useSelector((state) => state.authData);
  const fyIdRef = useRef(localStorage.getItem('globalDateId'));
  const fyList = financialYears.payload.fy_list;
  const handlePageTrigger = () => {
      fyIdRef.current = localStorage.getItem('globalDateId');
  }
  const [open, setOpen] = useState(false);
  const [filterPayload, setFilterPayload] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: "",
        consolidate: false,
    })
    const [filterApplied, setFilterApplied] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: "",
        consolidate: false,
    });
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleInput = async (e) => {
        const {name, value} = e.target;
        setFilterPayload((prev) => ({
            ...prev, [name]: value
        }));
    }

    const handleFilterRemove = async (name) => {
        const newPayload = {
        ...filterPayload,
        [name]: "",
        };
        setFilterPayload(newPayload);
        setFilterApplied(newPayload);
    }

    const handleFilterClick = async () => {
        setFilterApplied(filterPayload);
        setOpen(false);
    }
  return (
    <div>
      <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
      <div className='scheme p-2'>
        <DashboardFilter
            openFilterModal={setOpen}
            filterPayload={filterApplied}
            handleFilterRemove={handleFilterRemove}
            isTierRemovalRequired={true}
        />
        <ManageUser searchStr={filterApplied.searchStr} department_level={filterApplied.tier} departmentId={filterApplied.department_id} />
      </div>
      { authData.user.user_type === 'l3' && <CreateButton title={"Add User"} url={"/add-user"}/> }
      <MainFilter
        open={open}
        handleClose={handleClose}
        handleInput={handleInput}
        handleOpen={handleOpen}
        handleFilterClick={handleFilterClick}
        filterPayload={filterPayload}
        type="User"
      />
    </div>
  )
}

export default Users
